/**
 * devops API 모음
 * (참고) devops API는 회사 외부의 리소스를 포함하는 하는 경우에 사용 (chat GPT, 파일 업로드 등)
 * (참고) 손드젠임
 * */

import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';

import type { RequestOptions } from '@inflearn/datasource-rest';
import { devopsFetcher } from '../Fetcher';

export const API_ENDPOINT = {
  V1_FAQ_ASK: `/v1/faq/ask`,
};

/**
 * GET GPT 격려 메시지
 * */
export type V1FaqAskResponse = {
  /**
   * 응답데이터
   */
  data: {
    success: boolean;
    answer: string;
  };
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string;
};

export const fetchV1FaqAsk = async (url: string, requestOptions?: RequestOptions) =>
  devopsFetcher.get<V1FaqAskResponse>(url, requestOptions);

export function getV1FaqAskOptions({
  queryKey,
  url,
  options,
  requestOptions,
}: {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<V1FaqAskResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}) {
  return {
    queryKey,
    queryFn: () => fetchV1FaqAsk(url, requestOptions),
    ...options,
  };
}
